<form [formGroup]="form" class="space-y-5 mt-2" (submit)="save()">

  <!-- Mode toggle -->
  <p-selectbutton
    [(ngModel)]="inputMode"
    [ngModelOptions]="{standalone: true}"
    [options]="modeOptions"
    optionLabel="label"
    optionValue="value"
    (onChange)="onModeChange()"
    styleClass="w-full"
  />

  <!-- Manual number input -->
  @if (inputMode === 'number') {
    <div class="flex items-center gap-2">
      <p-select
        formControlName="prefix"
        [options]="phonePrefixes"
        optionLabel="label"
        optionValue="value"
        styleClass="w-40"
        appendTo="body"
      />
      <p-float-label variant="on" class="flex-1">
        <input
          pInputText
          id="localNumber"
          formControlName="localNumber"
          class="w-full"
          type="tel"
          inputmode="numeric"
          pattern="[0-9]*"
          autocomplete="off"
        />
        <label for="localNumber">Numero di telefono</label>
      </p-float-label>
    </div>
  }

  <!-- Contact autocomplete -->
  @if (inputMode === 'contact') {
    <p-float-label variant="on" class="w-full">
      <p-autocomplete
        inputId="contactSearch"
        [suggestions]="contactSuggestions"
        [forceSelection]="true"
        [field]="'firstName'"
        (completeMethod)="onContactSearch($event)"
        (onSelect)="onContactSelect($event.value)"
        styleClass="w-full"
        appendTo="body"
        [minLength]="2"
        placeholder=" "
      >
        <ng-template #item let-contact>
          <div class="flex flex-col gap-0.5">
            <span class="font-medium">{{ contactLabel(contact) }}</span>
            @if (contact.phoneNumbers.length > 0) {
              <span class="text-xs text-surface-500">
                {{ contact.phoneNumbers[0].phoneNumber }}
                @if (contact.phoneNumbers.length > 1) {
                  <span> +{{ contact.phoneNumbers.length - 1 }} altri</span>
                }
              </span>
            }
          </div>
        </ng-template>
      </p-autocomplete>
      <label for="contactSearch">Cerca per nome o telefono</label>
    </p-float-label>

    <!-- Phone number picker — shown only when contact has multiple phones -->
    @if (selectedContact && selectedContact.phoneNumbers.length > 1) {
      <div class="space-y-2">
        <p class="text-sm text-surface-600 font-medium">Seleziona numero da usare</p>
        <div class="flex flex-col gap-2">
          @for (phone of selectedContact.phoneNumbers; track phone.phoneNumber) {
            <button
              type="button"
              class="flex items-center justify-between px-3 py-2 rounded-lg border text-sm transition-colors"
              [class.border-primary-500]="selectedPhone?.phoneNumber === phone.phoneNumber"
              [class.bg-primary-50]="selectedPhone?.phoneNumber === phone.phoneNumber"
              [class.border-surface-300]="selectedPhone?.phoneNumber !== phone.phoneNumber"
              (click)="selectPhone(phone)"
            >
              <span class="font-mono">{{ phone.phoneNumber }}</span>
              <span class="flex items-center gap-2 text-surface-500">
                @if (phone.label) { <span>{{ phone.label }}</span> }
                @if (phone.isPrimary) { <i class="pi pi-star-fill text-yellow-400 text-xs"></i> }
                @if (selectedPhone?.phoneNumber === phone.phoneNumber) {
                  <i class="pi pi-check text-primary-500"></i>
                }
              </span>
            </button>
          }
        </div>
      </div>
    }

    <!-- Phone preview once resolved -->
    @if (selectedContact && form.get('localNumber')?.value) {
      <div class="flex items-center gap-2 px-3 py-2 rounded-lg bg-surface-50 border border-surface-200 text-sm">
        <i class="pi pi-phone text-primary-500"></i>
        <span class="font-mono text-surface-700">+{{ form.get('prefix')?.value }} {{ form.get('localNumber')?.value }}</span>
      </div>
    }
  }

  <p-floatlabel class="w-full" variant="on">
    <p-select
      inputId="priority"
      formControlName="priority"
      [options]="priorityOptions"
      optionLabel="label"
      optionValue="value"
      class="w-full"
      appendTo="body"
    />
    <label for="priority">Priorità</label>
  </p-floatlabel>

  <p-floatlabel class="w-full" variant="on">
    <p-select
      inputId="status"
      formControlName="status"
      [options]="statusOptions"
      optionLabel="label"
      optionValue="value"
      class="w-full"
      appendTo="body"
    />
    <label for="status">Stato</label>
  </p-floatlabel>

  <div class="flex justify-end gap-2 pt-2">
    <p-button label="Cancella" icon="pi pi-times-circle" size="small" severity="secondary" type="button" (click)="closeDialog()"/>
    <p-button label="Crea" icon="pi pi-check-circle" size="small" [disabled]="form.invalid || !isContactModeValid" type="submit"/>
  </div>

</form>
